export const OCCUPATION_LIST = [
  { key: 'Salaried', label: 'Salaried' },
  { key: 'Self-employed', label: 'Self-employed' },
  { key: 'Student', label: 'Student' },
  { key: 'Homemaker', label: 'Homemaker' },
  { key: 'Unemployed', label: 'Unemployed' }
];

export const QUALIFICATION_LIST = [
  { key: '10th/12th pass', label: '10th/12th pass' },
  { key: 'Graduate', label: 'Graduate' },
  { key: 'Postgraduate (Masters, PHD, etc.)', label: 'Postgraduate (Masters, PHD, etc.)' },
  { key: 'Below 10th pass', label: 'Below 10th pass' }
];
